export default {
  ELI_START_SCREEN: 'controllers/scenes/StartScreen',
  ELI_MAIN: 'controllers/scenes/Main',
  ELI_FRUIT: 'controllers/fruits/ControllerFruit'
}
